export default __webpack_public_path__ + "static/media/ic_add_image_file.0258ef92.svg";